import { useState, useCallback } from "react";

export function useAsyncFunction(asyncFunction) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const execute = useCallback(async (...args) => {
        setLoading(true);
        setError(null);
        try {
        const result = await asyncFunction(...args);
        return result;
        } catch (err) {
        setError(err);
        throw err;
        } finally {
        setLoading(false);
        }
    }, [asyncFunction]);

    return { loading, error, execute };
}